import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import VueXAlong from "vuex-along";
const Store = new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  plugins: [VueXAlong()]
});

export default Store;



// WEBPACK FOOTER //
// ./src/store/index.js